import classNames from 'classnames';
import { ComponentProps } from 'react';
import { Heading } from 'yoso';
import { Currency } from '~/components/Currency';
import { Boost2D, D } from '~/components/Icon';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { SaleNftModel } from '~/components/Nft/Nft.hooks';
import { AutoSizeText } from '~/components/Text/AutoSize/AutoSizeText';
import { abbreviate, format, formatBoost } from '~/components/Util/number';
import styles from './MarketplaceNftCard.module.scss';

/* eslint-disable @typescript-eslint/no-unused-vars */
//TODO: Replace Content with NftContent
export type MarketplaceNftCardProps = SaleNftModel & Omit<ComponentProps<'div'>, 'id' | 'title'>;
export const MarketplaceNftCard = ({
  id,
  title,
  primaryPrice,
  primaryCurrency,
  secondaryPrice,
  secondaryCurrency,
  originContentsUrl,
  contentsUrl,
  contentsType,
  serialNumber,

  owner,
  saleId,
  likeCount,
  liked,
  marketSaleId,
  labels,
  imageLabels,
  optionLabels: [boostLabel] = [],
  onSale,
  goodsProperties,
  rewardAssetType,
  rewardAmount,
  tokenType,
  className,
  ...props
}: MarketplaceNftCardProps) => {
  const hasSecondaryCurrency = secondaryCurrency !== null && secondaryPrice !== null;
  return (
    <div className={classNames(styles.root, className)} {...props}>
      <img src={contentsUrl} alt={title} className={styles.content} />
      <Heading level={6} className={styles.title}>
        {title}
      </Heading>
      <AutoSizeText className={styles.price}>
        <span className={styles.pair}>
          <Currency
            className={styles.primary}
            currency={primaryCurrency}
            value={primaryPrice}
            minimumFractionDigits={0}
          />
          {hasSecondaryCurrency && (
            <small className={styles.secondary}>
              ≈
              <Currency
                currency={secondaryCurrency}
                value={secondaryPrice}
                minimumFractionDigits={0}
              />
            </small>
          )}
        </span>
      </AutoSizeText>
      <DescriptionList className={styles.list} layout="responsive">
        {!!rewardAmount && (
          <>
            <dt>
              <D className={styles.icon} />
            </dt>
            <dd>{rewardAmount > 999999 ? abbreviate(rewardAmount) : format(rewardAmount)}</dd>
          </>
        )}
        {boostLabel && (
          <>
            <dt>
              <Boost2D className={styles.icon} />
            </dt>
            <dd>{formatBoost(boostLabel.imageLabel)}%</dd>
          </>
        )}
      </DescriptionList>
    </div>
  );
};
